import { render } from "./tm-receive-red-packet-popup.vue?vue&type=template&id=7bd39f1c&scoped=true&ts=true"
import script from "./tm-receive-red-packet-popup.vue?vue&type=script&lang=ts"
export * from "./tm-receive-red-packet-popup.vue?vue&type=script&lang=ts"

import "./tm-receive-red-packet-popup.vue?vue&type=style&index=0&id=7bd39f1c&lang=scss&scoped=true"

import exportComponent from "/Users/panren/Desktop/太平洋网络/discount-topics-wap-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd39f1c"]])

export default __exports__